<template>
  <div>
    <!-- <v-app-bar class="d-flex align-center justify-space-between"> -->
    <v-app-bar color="white">
      <!-- TODO: Remove mobile nav -->
      <v-app-bar-nav-icon
        @click="drawer = true"
        class="d-flex d-sm-none"
      ></v-app-bar-nav-icon>
      <v-container fluid class="d-flex align-center justify-space-between">
        <router-link to="/">
          <v-img
            src="https://hrng-assets.s3.amazonaws.com/HRN_Glogo_09b879e9de.png"
            class="hrng-logo"
            maxHeight="40"
            maxWidth="120"
          />
        </router-link>

        <NavMenu
          desktop="true"
          v-if="loggedIn && loggedInType === 'candidate'"
          class="d-none d-sm-flex"
        />

        <v-spacer></v-spacer>

        <div>
          <div v-if="!loggedIn">
            <AuthModal
              buttonText="Login"
              mobileButtonText="Login"
              dark
              color="#0274b3"
            />
          </div>
          <div v-else>
            <v-btn dark color="#0274b3" large @click="handleLogout"
              >Logout</v-btn
            >
          </div>
        </div>
      </v-container>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <NavMenu />
    </v-navigation-drawer>
  </div>
</template>

<script>
import NavMenu from '@/components/NavMenu';
import AuthModal from '@/components/Auth/AuthModal';
import { authComputed } from '@/store/helpers';

export default {
  components: { NavMenu, AuthModal },

  data: () => ({
    drawer: false,
  }),

  computed: {
    ...authComputed,
    loggedInType() {
      return this.getUserData.type;
    },
  },
  methods: {
    handleLogout() {
      this.$store.dispatch('LOGOUT');
    },
  },
};
</script>

<style lang="scss">
.v-app-bar {
  z-index: 2;
}
.v-toolbar__title {
  width: 110px;
  .hrng-logo {
    width: 100%;
  }
}

/* .v-app-bar {
  height: 85px !important;
} */
</style>
